import { permissionActions } from '../constants/permissionConstant'
import { User } from '../store/reducers/userReducer'
import {
  PermissionAction,
  PermissionName,
  PermissionType,
} from '../types/generalTypes'

const hasPermission = (
  user: User,
  permissionName: PermissionName,
  permissionAction?: PermissionAction,
  permissionType?: PermissionType
) => {
  if (!user || !user.rolePermissions) {
    return false
  }

  const permissionFound = user.rolePermissions.find((permission) => {
    if (permission === permissionActions.ALL) {
      return true
    }

    const permissionSplitted = permission.split(':')
    if (permissionAction && permissionType) {
      return (
        permissionSplitted[0].includes(permissionName) &&
        permissionSplitted[1].includes(permissionAction) &&
        permissionSplitted[2].includes(permissionType)
      )
    } else if (permissionAction) {
      return (
        permissionSplitted[0].includes(permissionName) &&
        permissionSplitted[1].includes(permissionAction)
      )
    } else {
      return permissionSplitted[0].includes(permissionName)
    }
  })
  return !!permissionFound
}

interface HasUiFlagProps {
  uiFlag: number
  flagsToCheck: number
}
const hasUiFlag = ({ uiFlag, flagsToCheck }: HasUiFlagProps): boolean => {
  return uiFlag !== undefined && flagsToCheck !== undefined
    ? (uiFlag & flagsToCheck) !== 0
    : false
}

const roleService = {
  hasPermission,
  hasUiFlag,
}

export default roleService
